import { render, staticRenderFns } from "./ProductionsGrid.vue?vue&type=template&id=01b81ac2&scoped=true"
import script from "./ProductionsGrid.vue?vue&type=script&lang=js"
export * from "./ProductionsGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductionsGrid.vue?vue&type=style&index=0&id=01b81ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b81ac2",
  null
  
)

export default component.exports